var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarInfoStreamax",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar General Streamax"
                                                : "Ver Detalle General Time Streamax"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.dateFormat.label,
                                          items:
                                            _vm.formFields.dateFormat.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedDateFormat,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.dateFormat.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.dateFormat,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.dateFormat.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.timeFormat.label,
                                          items:
                                            _vm.formFields.timeFormat.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedTimeFormat,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.timeFormat.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.timeFormat,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.timeFormat.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: _vm.formFields.timeZone.label,
                                          items: _vm.formFields.timeZone.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedTimeZone,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.timeZone.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.timeZone,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.timeZone.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }